require('bootstrap');

axios.defaults.withCredentials = true;